export default {
  updateLocale(state, locale) {
    state.locale = locale || 'id'
  },
  updateInvestments(state, investments) {
    state.investments = investments || []

    let fixedList = []
    let flexibleList = []
    let trialProductList = []
    let newProductList = []
    if ('FIXED' in investments) {
      fixedList = investments.FIXED
    }
    if ('FLEXIBLE' in investments) {
      flexibleList = investments.FLEXIBLE
    }
    // 体验标
    if ('FIXED_TRIAL' in investments) {
      trialProductList = investments.FIXED_TRIAL
    }
    if ('FIXED_NEO' in investments) {
      newProductList = investments.FIXED_NEO
    }
    state.fixedProducts = fixedList
    state.flexibleProducts = flexibleList
    state.trialProducts = trialProductList
    state.newProducts = newProductList
  },
  updateCurrentProduct(state, product) {
    state.currentProduct = product || {}
  },
  updateCouponList(state, list) {
    state.couponList = list
  },
  updateUserInfo(state, info) {
    state.userInfo = info || null
  },
  updateAccountInfo(state, overview) {
    state.accountOverview = overview || null
  },
  updateCurrentRecord(state, record) {
    state.currentRecord = record || null
  },
  updateInviteCode(state, data) {
    state.inviteCode = data || ''
  },
}
